module.exports = __webpack_public_path__ + "static/img/son8_active.0347fd2a.png";